export default "__VITE_ASSET__b7e6e287__"